const tabs = { all: 'all', topics: 'topic', comments: 'comment' };
const integer = value => Number.isSafeInteger(value) && value >= 0;
const id = value => (typeof value === 'string' || typeof value === 'number' && Number.isSafeInteger(value)) && /^(?:[1-9]\d*)$/.test(String(value)) ? String(value) : null;
const invalid = () => new Error('La respuesta de pendientes no es válida. Vuelve a consultar la lista.');
const stale = () => Object.assign(new Error('La sesión ha cambiado.'), { code: 'stale_response' });

export function legacyPendingQuery(query = {}) {
  const tab = query.tab || 'all', page = query.page === undefined ? 1 : Number(query.page);
  if (!Object.prototype.hasOwnProperty.call(tabs, tab) || !Number.isSafeInteger(page) || page < 1) throw new Error('El filtro o la página de pendientes no son válidos.');
  return { tab, page, params: { type: tabs[tab], page: page - 1, limit: 10 } };
}

export function mapLegacyPending(raw, tab) {
  const pagination = raw && raw.pagination, counts = pagination && pagination.total;
  if (raw?.success !== true || !counts || !['all', 'topics', 'comments'].every(key => integer(counts[key])) || counts.all !== counts.topics + counts.comments || !integer(pagination.page) || !Number.isSafeInteger(pagination.pages) || pagination.pages < 1 || pagination.page >= pagination.pages || pagination.limit !== 10 || !Array.isArray(raw.results?.topics) || !Array.isArray(raw.results?.comments)) throw invalid();
  const items = [];
  for (const type of ['topic', 'comment']) for (const row of raw.results[type + 's']) {
    const nid = id(row.nid), cid = type === 'comment' ? id(row.cid) : null, postId = cid || nid;
    if (!nid || type === 'comment' && !cid || !integer(row.created) || typeof row.author?.name !== 'string' || tab !== 'all' && type !== tabs[tab]) throw invalid();
    const title = type === 'topic' ? row.title : row.subject || 'RE: ' + row.topic_title;
    if (typeof title !== 'string') throw invalid();
    items.push({ id: postId, nid, cid, type, title, topic_title: type === 'comment' ? row.topic_title : null,
      author: { name: row.author.name }, created: row.created, resolving: false, preview: '',
      url: { name: 'ForumThread', params: { nid }, ...(cid ? { query: { comment_id: cid }, hash: '#comment-' + cid } : {}) } });
  }
  const total = counts[tab], expected = Math.min(10, Math.max(0, total - pagination.page * 10));
  if (items.length !== expected || pagination.pages !== Math.max(1, Math.ceil(total / 10)) || new Set(items.map(item => item.type + ':' + item.id)).size !== items.length) throw invalid();
  items.sort((a, b) => b.created - a.created || a.type.localeCompare(b.type) || b.id.length - a.id.length || b.id.localeCompare(a.id));
  return { items, counts: { ...counts }, page: pagination.page + 1, pages: pagination.pages, tab };
}

export function createLegacyPendingRepository({ http, getIdentity }) {
  const flights = new Map(), identity = () => JSON.stringify(getIdentity() || {});
  function run(key, owner, task) {
    if (flights.has(key)) return flights.get(key);
    const current = () => { if (identity() !== owner) throw stale(); };
    const request = Promise.resolve().then(() => { current(); return task(current); }).finally(() => { if (flights.get(key) === request) flights.delete(key); });
    flights.set(key, request); return request;
  }
  return {
    async read(query) {
      const input = legacyPendingQuery(query), owner = identity(), key = 'read:' + owner + ':' + JSON.stringify(input.params);
      return run(key, owner, async current => {
        const response = await http.get('/forum/api/need-response/get', { params: input.params, timeout: 15000 });
        current(); return mapLegacyPending(response.data, input.tab);
      });
    },
    async resolve(item) {
      if (!id(item.nid) || !id(item.id) || !['topic', 'comment'].includes(item.type) || item.type === 'topic' && String(item.nid) !== String(item.id)) throw invalid();
      const owner = identity(), key = 'resolve:' + owner + ':' + item.nid + ':' + item.type + ':' + item.id;
      return run(key, owner, async current => {
        const payload = { value: false, post_type: item.type, topic_id: item.nid, ...(item.type === 'comment' ? { comment_id: item.id } : {}) };
        const response = await http.post('/forum/api/need-response/set', payload, { timeout: 15000 }); current();
        const data = response.data;
        if (data?.success !== true || data.needsResponse !== false || data.type !== item.type || String(data.id) !== String(item.id)) throw invalid();
        return true;
      });
    }
  };
}
